import Vue from "vue"
import Vuex from "vuex"
 
Vue.use(Vuex);
 
export default new Vuex.Store({
    state:{
        pathName: "",
    },
    mutations:{
        setNumber(state,payload){
            state.pathName = payload;
        },
    },
    actions:{
        setSearch(context,value){
            context.commit("setNumber",value)
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js